import ScaleLoader from 'react-spinners/ScaleLoader';

const override = {
  display: 'block',
  margin: '50px auto',
};

const Spinner = ({ loading }) => {
  return (
    <ScaleLoader
      color='#4269f5'
      loading={loading}
      cssOverride={override}
      size={100}
    />
  );
};
export default Spinner;
